import { EVoteReason, EPostStatus } from '@constants';

export const CommonDashboardTranslations = {
  HI: {
    es: 'Hola, {{name}}!',
    en: 'Hi, {{name}}!',
    cat: 'Hola, {{name}}!',
    eus: 'Kaixo, {{name}}!',
    pt: 'Olá, {{name}}!'
  },
  NEWS: {
    es: 'Noticias',
    en: 'News',
    cat: 'Notícies',
    eus: 'Berriak',
    pt: 'Notícias'
  },
  COURSES: {
    es: 'cursos',
    en: 'courses',
    cat: 'cursos',
    eus: 'ikastaroak',
    pt: 'cursos'
  },
  FILES: {
    es: 'Archivos',
    en: 'Files',
    cat: 'Fitxers',
    eus: 'Fitxategiak',
    pt: 'Ficheiros'
  },
  DOUBTS: {
    es: 'Dudas',
    en: 'Doubts',
    cat: 'Dubtes',
    eus: 'Zalantzak',
    pt: 'Dúvidas'
  },
  NEXT_EVENTS: {
    es: 'Próximos eventos',
    en: 'Next events',
    cat: 'Propers esdeveniments',
    eus: 'Hurrengo ekitaldiak',
    pt: 'Próximos eventos'
  },
  REPORTS: {
    es: 'Reportes',
    en: 'Reports',
    cat: 'Informes',
    eus: 'Txostenak',
    pt: 'Relatórios'
  },
  NO_EVENTS_IN_THIS_MONTH: {
    es: 'No hay eventos programados para {{month}}.',
    en: 'No events scheduled for {{month}}.',
    cat: 'No hi ha esdeveniments programats per {{month}}.',
    eus: '{{month}}rako ez dago ekitaldirik egiteko.',
    pt: 'Não há eventos programados para {{month}}.'
  },
  POST_TITLE: {
    es: 'Título',
    en: 'Title',
    cat: 'Títol',
    eus: 'Izenburua',
    pt: 'Título'
  },
  POST_TITLE_PLACEHOLDER: {
    es: 'Escribe un título',
    en: 'Write a title',
    cat: 'Escriu un títol',
    eus: 'Izenburua idatzi',
    pt: 'Escreva um título'
  },
  POST_CONTENT: {
    es: 'Contenido',
    en: 'Content',
    cat: 'Contingut',
    eus: 'Edukia',
    pt: 'Conteúdo'
  },
  DOUBTS_TITLE: {
    es: 'Dudas',
    en: 'Doubts',
    cat: 'Dubtes',
    eus: 'Zalantzak',
    pt: 'Dúvidas'
  },
  INFO_OPTION_STUDENTS: {
    es: 'alumnos',
    en: 'students',
    cat: 'alumnes',
    eus: 'ikasleak',
    pt: 'alunos'
  },
  INFO_OPTION_TEACHERS: {
    es: 'profesores',
    en: 'teachers',
    cat: 'professors',
    eus: 'irakasleak',
    pt: 'professores'
  },
  INFO_OPTION_COURSES: {
    es: 'cursos',
    en: 'courses',
    cat: 'cursos',
    eus: 'ikastaroak',
    pt: 'cursos'
  },
  NO_NEWS_TO_SHOW: {
    es: 'No hay noticias para mostrar.',
    en: 'No news to show.',
    cat: 'No hi ha notícies per mostrar.',
    eus: 'Ez dago albisterik erakusteko.',
    pt: 'Não há notícias para mostrar.'
  },
  NEWS_PUBLISHED_SUCCESS: {
    es: 'La noticia se ha publicado con éxito.',
    en: 'The news has been published successfully.',
    cat: 'La notícia s’ha publicat amb èxit.',
    eus: 'Berria argitaratua da ongi.',
    pt: 'A notícia foi publicada com sucesso.'
  },
  NEWS_SCHEDULED_SUCCESS: {
    es: 'La noticia se ha programado con éxito.',
    en: 'The news has been scheduled successfully.',
    cat: 'La notícia s’ha programat amb èxit.',
    eus: 'Berria planifikatua da ongi.',
    pt: 'A notícia foi programada com sucesso.'
  },
  NEWS_DRAFT_SUCCESS: {
    es: 'La noticia se ha guardado como borrador.',
    en: 'The news has been saved as a draft.',
    cat: 'La notícia s’ha guardat com a borrador.',
    eus: 'Berria zuzendua da.',
    pt: 'A notícia foi guardada como rascunho.'
  },
  STATS: {
    es: 'Descargar estadísticas',
    en: 'Download stats',
    cat: 'Descarregar estadístiques',
    eus: 'Estatistikak deskargatu',
    pt: 'Estatísticas descarregadas'
  },
  DOWNLOAD_CSAT: {
    es: 'CSAT',
    en: 'CSAT',
    cat: 'CSAT',
    eus: 'CSAT',
    pt: 'CSAT'
  },
  DOWNLOAD_TICKETS: {
    es: 'Dudas',
    en: 'Tickets',
    cat: 'Tickets',
    eus: 'Dudak',
    pt: 'Tickets'
  },
  DOWNLOAD_ACTIVITY_RATING: {
    es: 'Valoraciones',
    en: 'Activity rating',
    cat: 'Valoracions',
    eus: 'Balorazioak',
    pt: 'Valoraciones'
  },
  DOWNLOAD_UPLOADED_FILES: {
    es: 'Archivos subidos',
    en: 'Uploaded files',
    cat: 'Fitxers pujats',
    eus: 'Igotako fitxategiak',
    pt: 'Ficheiros carregados'
  },
  NEXT_LIVE_CLASSES: {
    es: 'Próximas clases en directo',
    en: 'Next live classes',
    cat: 'Properes classes en viu',
    eus: 'Hurrengo klaseak zuzenean',
    pt: 'Próximas aulas ao vivo'
  },
  CREATE_LIVE_CLASS: {
    es: 'Crear clase',
    en: 'Create class',
    cat: 'Crear classe',
    eus: 'Sortu klase',
    pt: 'Criar aula'
  },
  YOUR_CLASSES: {
    es: 'Das clase en estos cursos:',
    en: 'You teach in these courses:',
    cat: 'Donar classe en aquests cursos:',
    eus: 'Klaseak eman ikastaro hauek:',
    pt: 'Ensinar em estes aulas:'
  },
  PENDING_TASKS: {
    es: 'Actividades pendientes de realizar',
    en: 'Pending activities to perform',
    cat: 'Activitats pendents de realitzar',
    eus: 'Egin beharreko jarduera pendienteak',
    pt: 'Tarefas pendentes de realizar'
  },
  PENDING_TASKS_COUNT: {
    es: '{{ totalTasks }} actividades pendientes',
    en: '{{ totalTasks }} pending activities',
    cat: '{{ totalTasks }} activitats pendents',
    eus: '{{ totalTasks }} jarduera pendiente',
    pt: '{{ totalTasks }} tarefas pendentes'
  },
  TASK_NOT_ON_YOUR_COURSES: {
    es: 'Esta tarea está asociada a un curso que no impartes.',
    en: 'This task is associated with a course you do not teach.',
    cat: 'Aquesta tasca està associada a un curs que no impartiu.',
    eus: 'Jarduera hau irakas ezazun ikastarora lotuta dago.',
    pt: 'Esta tarefa está associada a um curso que não ensina.'
  },
  DEADLINE_DATE: {
    es: 'Fecha máxima de entrega:',
    en: 'Deadline date:',
    cat: 'Data màxima d’entrega:',
    eus: 'Entregako epea:',
    pt: 'Data máxima de entrega:'
  },
  ASSIGNED_TO: {
    es: 'Asignada a:',
    en: 'Assigned to:',
    cat: 'Assignada a:',
    eus: 'Asignatua:',
    pt: 'Atribuída a:'
  },
  EDIT_CONTENT: {
    es: 'Editar contenido',
    en: 'Edit content',
    cat: 'Editar contingut',
    eus: 'Editatu edukia',
    pt: 'Editar conteúdo'
  },
  TASK_HISTORY: {
    es: 'Historial de la tarea',
    en: 'Task history',
    cat: 'Historial de la tasca',
    eus: 'Lanaren historia',
    pt: 'Histórico da tarefa'
  },
  OPEN_DOUBTS: {
    es: 'Dudas abiertas',
    en: 'Open doubts',
    cat: 'Dubtes oberts',
    eus: 'Zabalik dauden zalantzak',
    pt: 'Dúvidas abertas'
  },
  NO_SCHEDULED_EVENTS_TITLE: {
    es: 'No hay eventos',
    en: 'There are no events',
    cat: 'No hi ha esdeveniments',
    eus: 'Ez dago ekitaldirik',
    pt: 'Não há eventos'
  },
  NO_SCHEDULED_EVENTS_DESCRIPTION: {
    es: 'No hay ningún evento de tu formación programado para los próximos 30 días.',
    en: 'There are no events from your formation scheduled for the next 30 days.',
    cat: 'No hi ha cap esdeveniment de la teva formació programat pels propers 30 dies.',
    eus: 'Ez dago zure formazioko ekitaldirik programatuta hurrengo 30 egunetarako.',
    pt: 'Não há eventos da sua formação programados para os próximos 30 dias.'
  },
  NO_PENDING_TASKS_TITLE: {
    es: 'Vaya, vaya, vaya...',
    en: 'Oops, oops, oops...',
    cat: 'Uy, uy, uy...',
    eus: 'Epa, epa, epa...',
    pt: 'Oops, oops, oops...'
  },
  NO_PENDING_TASKS_DESCRIPTION: {
    es: 'Parece que eres tan crack que no tienes ninguna tarea pendiente. Si quieres tareas puedes solicitarlas por el chat.',
    en: 'It seems that you are so crack that you do not have any pending tasks. If you want tasks you can request them through the chat.',
    cat: 'Sembla que ets tan crack que no tens cap tasca pendent. Si vols tasques pots sol·licitar-les pel xat.',
    eus: 'Zuretzat ez dago zeregin pendienteik, zuk zereginak eskatu ditzakezu txaten bidez.',
    pt: 'Parece que você é tão crack que não tem nenhuma tarefa pendente. Se quiser tarefas, pode solicitá-las através do chat.'
  },
  NO_OPEN_DOUBTS_TITLE: {
    es: 'Sin dudas abiertas',
    en: 'Without open doubts',
    cat: 'Sense dubtes oberts',
    eus: 'Zalantzarik gabe',
    pt: 'Sem dúvidas abertas'
  },
  NO_OPEN_DOUBTS_DESCRIPTION: {
    es: 'O tus alumnos son genios y no tienen dudas o eres el más rápido del oeste respondiéndolas.',
    en: 'Either your students are geniuses and have no doubts or you are the fastest in the west answering them.',
    cat: 'O els teus alumnes són genis i no tenen dubtes o ets el més ràpid de l’oest responent-los.',
    eus: 'Zure ikasleak genioak dira eta ez dute zalantzarik edo zure erantzunak oso azkarak dira.',
    pt: 'Os seus alunos são genios e não têm dúvidas ou você é o mais rápido no oeste respondendo-as.'
  },
  IMAGE: {
    es: 'Imagen',
    en: 'Image',
    cat: 'Imatge',
    eus: 'Irudia',
    pt: 'Imagem'
  },
  [EPostStatus.PUBLISHED]: {
    es: 'Publicado',
    en: 'Published',
    cat: 'Publicat',
    eus: 'Argitaratua',
    pt: 'Publicado'
  },
  TOPIC: {
    es: 'Tema',
    en: 'Topic',
    cat: 'Tema',
    eus: 'Gaia',
    pt: 'Tema'
  },
  CONTENT: {
    es: 'Contenido',
    en: 'Content',
    cat: 'Contingut',
    eus: 'Edukia',
    pt: 'Conteúdo'
  },
  TAGS: {
    es: 'Formaciones',
    en: 'Formations',
    cat: 'Formacions',
    eus: 'Formazioak',
    pt: 'Formações'
  },
  SELECT_TOPIC: {
    es: 'Selecciona un tema',
    en: 'Select a topic',
    cat: 'Selecciona un tema',
    eus: 'Hautatu gaia',
    pt: 'Selecionar tema'
  },
  CREATE: {
    es: 'Crear',
    en: 'Create',
    cat: 'Crear',
    eus: 'Sortu',
    pt: 'Criar'
  },
  UPDATE: {
    es: 'Actualizar',
    en: 'Update',
    cat: 'Actualitzar',
    eus: 'Eguneratu',
    pt: 'Atualizar'
  },
  ADD: {
    es: 'Agregar',
    en: 'Add',
    cat: 'Afegir',
    eus: 'Gehitu',
    pt: 'Adicionar'
  },
  NEW_TOPIC: {
    es: 'Nuevo tema',
    en: 'New topic',
    cat: 'Nou tema',
    eus: 'Gaia berria',
    pt: 'Novo tema'
  },
  SLUG: {
    es: 'Slug',
    en: 'Slug',
    cat: 'Slug',
    eus: 'Slug',
    pt: 'Slug'
  },
  DELETE: {
    es: 'Eliminar',
    en: 'Delete',
    cat: 'Eliminar',
    eus: 'Ezabatu',
    pt: 'Eliminar'
  },
  DELETE_POST_CONFIRMATION: {
    es: '¿Estás seguro de eliminar este post?',
    en: 'Are you sure to delete this post?',
    cat: 'Estàs segur d`eliminar aquest post?',
    eus: 'Ziur zaude post hau ezabatu nahi duzula?',
    pt: 'Tem certeza que deseja eliminar este post?'
  },
  LECTURE_TIME: {
    es: 'Tiempo de lectura',
    en: 'Reading time',
    cat: 'Temps de lectura',
    eus: 'Irakurtzeko denbora',
    pt: 'Tempo de leitura'
  },
  SHORT_DESCRIPTION: {
    es: 'Descripción corta',
    en: 'Short description',
    cat: 'Descripció curta',
    eus: 'Deskribapen laburra',
    pt: 'Descrição curta'
  },
  CLASSES_AND_SYLLABUS: {
    es: 'Clases y temario',
    en: 'Classes and syllabus',
    cat: 'Classes i temari',
    eus: 'Klaseak eta syllabus',
    pt: 'Aulas e plano de estudo'
  },
  GO_TO_CONTENT: {
    es: 'Ir al contenido',
    en: 'Go to content',
    cat: 'Anar al contingut',
    eus: 'Joan edukira',
    pt: 'Ir para o conteúdo'
  },
  CHANGE_COURSE: {
    es: 'Cambiar curso',
    en: 'Change course',
    cat: 'Canviar curs',
    eus: 'Aldatu edukira',
    pt: 'Mudar curso'
  },
  WHAT_TO_DO_TODAY: {
    es: 'Qué hacer hoy',
    en: 'What to do today',
    cat: 'Què fer avui',
    eus: 'Egun hau zer egin',
    pt: 'O que fazer hoje'
  },
  MY_EXAM_GROUPS: {
    es: 'Mis convocatorias',
    en: 'My exam groups',
    cat: 'Les meves convocatories',
    eus: 'Nire azterketa taldeak',
    pt: 'Meus grupos de exames'
  },
  QUIZZES: {
    es: 'Tests',
    en: 'Tests',
    cat: 'Proves',
    eus: 'Probatzak',
    pt: 'Provas'
  },
  REVIEW_MODE_TITLE: {
    es: 'Corrige tus fallos',
    en: 'Review your mistakes',
    cat: 'Repassa els teus errors',
    eus: 'Berrikusi zure erroreak',
    pt: 'Revisar os seus erros'
  },
  REVIEW_MODE_DESCRIPTION: {
    es: 'Vuelve a responder las preguntas que fallaste en los tests anteriores.',
    en: 'Review the questions you have failed from any test you have taken.',
    cat: 'Repassa les preguntes que hagis fallat de qualsevol prova que hagis fet.',
    eus: 'Berrikusi zure galdu dituzun galderak egin dituzun edozein probatik.',
    pt: 'Revise as perguntas que falhou em qualquer prova que fez.'
  },
  TEST_HISTORY: {
    es: 'Historial de tests',
    en: 'Test history',
    cat: 'Historial de proves',
    eus: 'Probatzak historia',
    pt: 'Histórico de provas'
  },
  INVITE_A_FRIEND_AND_EARN: {
    es: 'Invita a un amigo y gana {{amount}}€* 💶🫰🤑',
    en: 'Invite a friend and earn {{amount}}€* 💶🫰🤑',
    cat: 'Convida un amic i guanya {{amount}}€* 💶🫰🤑',
    eus: 'Deitu lagun bati eta irabazi {{amount}}€* 💶🫰🤑',
    pt: 'Convidar um amigo e ganhar {{amount}}€* 💶🫰🤑'
  },
  INVITE_4_FRIENDS_AND_EARN: {
    es: 'Invita a 4 amigos y consigue 600€',
    en: 'Invite 4 friends and get 600€',
    cat: 'Convida 4 amics i aconsegueix 600€',
    eus: 'Deitu 4 lagunei eta lortu 600€',
    pt: 'Convidar 4 amigos e ganhar 600€'
  },
  EMAIL_OF_YOUR_FRIEND: {
    es: 'Email de tu amigo o amiga',
    en: 'Email of your friend',
    cat: 'Email del teu amic o amiga',
    eus: 'Zure lagunaren emaila',
    pt: 'Email do seu amigo ou amigo'
  },
  REFERRAL_MODAL_DESCRIPTION: {
    es: '*Nos pondremos en contacto contigo en caso de que se convierta en alumno de Ucademy para realizarte el pago.',
    en: '*We will contact you in case he becomes a Ucademy student to make the payment.',
    cat: '*Ens posarem en contacte amb tu en cas que es converteixi en alumne de Ucademy per realitzar-te el pagament.',
    eus: '*Zurekin harremanetan jarriko gara Ucademyko ikasle bihurtzen bada ordainketa egiteko.',
    pt: '*Entraremos em contato caso ele se torne aluno da Ucademy para realizar o pagamento.'
  },
  SEND_INVITATION: {
    es: 'Enviar invitación',
    en: 'Send invitation',
    cat: 'Enviar invitació',
    eus: 'Bidali gonbidapena',
    pt: 'Enviar convite'
  },
  EXIT: {
    es: 'Salir',
    en: 'Exit',
    cat: 'Sortir',
    eus: 'Irten',
    pt: 'Sair'
  },
  INVITATION_SENT: {
    es: '¡Invitación enviada!',
    en: 'Invitation sent!',
    cat: 'Invitació enviada!',
    eus: 'Gonbidapena bidalia!',
    pt: 'Convite enviado!'
  },
  INVITATION_FAILED: {
    es: '¡Ups! Algo ha fallado al enviar la invitación.',
    en: 'Oops! Something went wrong sending the invitation.',
    cat: '¡Ups! Alguna cosa ha fallat en enviar la invitació.',
    eus: '¡Ups! Zerbait gaizki joan da gonbidapena bidaltzean.',
    pt: '¡Ups! Algo falhou ao enviar o convite.'
  },
  HOW_LIKELY_IS_IT_THAT_YOU_WOULD_RECOMMEND_UCADEMY: {
    es: '¿Con qué probabilidad recomendarías Ucademy a un amigo?',
    en: 'How likely is it that you would recommend Ucademy to a friend?',
    cat: 'Amb quina probabilitat recomanaries Ucademy a un amic?',
    eus: 'Zer probabilitatearekin gomendatuko zenukezu Ucademy lagun bati?',
    pt: 'Com probabilidade você recomendaria Ucademy para um amigo?'
  },
  NOT_PROBABLE: {
    es: 'No lo recomendaría',
    en: 'I would not recommend it',
    cat: 'No recomanaria',
    eus: 'Ez da inoiz egin',
    pt: 'Não recomendo'
  },
  VERY_PROBABLE: {
    es: 'Lo recomendaría',
    en: 'I would recommend it',
    cat: 'Recomanaría',
    eus: 'Egin behar duzu egin',
    pt: 'Recomendo'
  },
  NEXT: {
    es: 'Siguiente',
    en: 'Next',
    cat: 'Següent',
    eus: 'Hurrengoa',
    pt: 'Próximo'
  },
  BACK: {
    es: 'Atrás',
    en: 'Back',
    cat: 'Enrere',
    eus: 'Atzera',
    pt: 'Voltar'
  },
  WRITE_HERE: {
    es: 'Escribe aquí...',
    en: 'Write here...',
    cat: 'Escriu aquí...',
    eus: 'Idatzi hemen...',
    pt: 'Escreva aqui...'
  },
  POST_NPS_NEUTRAL_TITLE: {
    es: '¡Gracias!',
    en: 'Thank you!',
    cat: 'Gràcies!',
    eus: 'Eskerrik asko!',
    pt: 'Obrigado!'
  },
  POST_NPS_NEUTRAL_SUBTITLE: {
    es: 'Trabajaremos en esos pequeños detalles para convertir tu nota en un 10.',
    en: 'We will work on those small details to convert your note into a 10.',
    cat: 'Treurem en compte aquests petits detalls per convertir la teva nota en un 10.',
    eus: 'Zure puntuazioa 10 egin nahi duen txikiek detaldeak kontuan hartuko dizkizkiz.',
    pt: 'Vamos trabalhar nesses pequenos detalhes para converter a sua nota em um 10.'
  },
  POST_NPS_PROMOTER_TITLE: {
    es: 'Tu opinión vale oro',
    en: 'Your opinion is gold',
    cat: 'La teva opinió val or',
    eus: 'Zure iruzkinak oro balio du',
    pt: 'Sua opinião vale ouro'
  },
  POST_NPS_PROMOTER_SUBTITLE: {
    es: '¿Nos dejas una reseña en Trustpilot?',
    en: 'Leave us a review on Trustpilot.',
    cat: 'Deixa-nos una ressenya a Trustpilot.',
    eus: 'Zure Trustpilot-en iruzkin bat utzi, mesedez.',
    pt: 'Sua opinião no Trustpilot vale ouro.'
  },
  POST_NPS_PROMOTER_SUBTITLE_2: {
    es: '¡Nos haría mucha ilusión leerte!',
    en: 'It would make us very happy to read your opinion.',
    cat: 'Ens faria molta il·lusió llegir la teva opinió.',
    eus: 'Gurekin harremanetan jarriko gara zure iruzkinaren emaitza gurekin.',
    pt: 'Gostaríamos muito de ler a sua opinião.'
  },
  POST_NPS_DETRACTOR_TITLE: {
    es: 'Tendremos en cuenta tu opinión',
    en: 'We will take your opinion into account',
    cat: 'Tindrem en compte la teva opinió',
    eus: 'Zure iruzkinak kontuan hartuko dizkizkiz',
    pt: 'Vamos ter em conta a sua opinião'
  },
  POST_NPS_DETRACTOR_SUBTITLE: {
    es: 'Valoraremos tus comentarios para convertir Ucademy en lo que TÚ quieres. ',
    en: 'We will value your comments to make Ucademy what YOU want.',
    cat: 'Valorarem els teus comentaris per fer Ucademy el que TÚ vols.',
    eus: 'Zure iruzkinak kontuan hartuko dizkizkiz Ucademy egin nahi duzun moduan.',
    pt: 'Valoraremos os seus comentários para tornar o Ucademy no que você quer.'
  },
  POST_NPS_DETRACTOR_SUBTITLE_2: {
    es: '¡Suerte y ánimo con el estudio!',
    en: 'Good luck and good study!',
    cat: 'Bon viatge i bons estudis!',
    eus: 'Ez zituen eta ezinbesteko ikastarok.',
    pt: 'Boa sorte e bom estudo!'
  },
  CLICK_HERE: {
    es: 'Haz click aquí 😁',
    en: 'Click here 😁',
    cat: 'Fes clic aquí 😁',
    eus: 'Klik egin hemen 😁',
    pt: 'Clique aqui 😁'
  },
  REGULAR_NPS_DETRACTOR_TITLE: {
    es: '¿Nos puedes contar que no te ha gustado?',
    en: 'Can you tell us what you did not like?',
    cat: 'Ens pots dir què no t’ha agradat?',
    eus: 'Esan dezakezu zer ez zait gustatu?',
    pt: 'Pode nos dizer o que não gostou?'
  },
  REGULAR_NPS_NEUTRAL_TITLE: {
    es: '¿Qué tendríamos que mejorar para que la próxima sea un 10?',
    en: 'What should we improve to get a 10 next time?',
    cat: 'Què hauríem de millorar perquè la propera sigui un 10?',
    eus: 'Zer hobetu behar genuke hurrengoan 10 bat jartzeko?',
    pt: 'O que deveríamos melhorar para obter um 10 na próxima vez?'
  },
  REGULAR_NPS_PROMOTER_TITLE: {
    es: '¿Qué es lo que más valoras de Ucademy?',
    en: 'What do you value most about Ucademy?',
    cat: 'Què és el que més valores de Ucademy?',
    eus: 'Zer baloratzen duzu gehien Ucademyren?',
    pt: 'O que valoriza mais em Ucademy?'
  },

  [`${EVoteReason.OTHER}`]: {
    es: 'Otro',
    en: 'Other',
    cat: 'Un altre',
    eus: 'Beste',
    pt: 'Outro'
  },
  [`${EVoteReason.VIDEO_CONTENT}`]: {
    es: 'Calidad del contenido (vídeos)',
    en: 'Content quality (videos)',
    cat: 'Qualitat del contingut (vídeos)',
    eus: 'Edukia bideo formatuan',
    pt: 'Conteúdo em formato de vídeo'
  },
  [`${EVoteReason.STUDY_MATERIAL}`]: {
    es: 'Material descargable (apuntes)',
    en: 'Downloadable study material (notes)',
    cat: 'Material descarregable (apunts)',
    eus: 'Deskargatu daitekeen materiala (oharrak)',
    pt: 'Material descargável (apontamentos)'
  },
  [`${EVoteReason.TEACHER_MONITORING}`]: {
    es: 'Seguimiento del profesorado',
    en: 'Teaching staff follow-up',
    cat: 'Seguiment del professorat',
    eus: 'Ikaslearen arreta taldea',
    pt: 'Acompanhamento do corpo docente'
  },

  [`${EVoteReason.INCOMPLETE_SYLLABUS}`]: {
    es: 'Temario incompleto',
    en: 'Incomplete syllabus',
    cat: 'Temari incomplet',
    eus: 'Programa osatugabea',
    pt: 'Programa incompleto'
  },
  [`${EVoteReason.LIVE_CLASSES}`]: {
    es: 'Clases en directo',
    en: 'Live classes',
    cat: 'Classes en directe',
    eus: 'Klaseak zuzenean',
    pt: 'Aulas ao vivo'
  },
  [`${EVoteReason.QUIZZES_QUANTITY}`]: {
    es: 'Más cantidad de tests',
    en: 'More quizzes',
    cat: 'Més proves',
    eus: 'Gehiago quizak',
    pt: 'Mais provas'
  },
  [`${EVoteReason.QUIZZES_QUALITY}`]: {
    es: 'Calidad de los tests',
    en: 'Quiz quality',
    cat: 'Qualitat dels tests',
    eus: 'Quizaren kualitatea',
    pt: 'Qualidade dos testes'
  },
  [`${EVoteReason.QUIZZES_FOR_PRACTICE}`]: {
    es: 'Test para practicar',
    en: 'Quiz for practice',
    cat: 'Prova per practicar',
    eus: 'Proba egin',
    pt: 'Prova para praticar'
  },
  [`${EVoteReason.MORE_QUIZZES_FOR_PRACTICE}`]: {
    es: 'Más tests para practicar',
    en: 'More quizzes for practice',
    cat: 'Més proves per practicar',
    eus: 'Gehiago probak egin',
    pt: 'Mais provas para praticar'
  },
  [`${EVoteReason.PLATFORM_FUNCTIONING}`]: {
    es: 'Funcionamiento de la plataforma',
    en: 'Platform functionality',
    cat: 'Funcionalitat de la plataforma',
    eus: 'Plataformaren funtzionamendua',
    pt: 'Informação insuficiente sobre a plataforma'
  },
  [`${EVoteReason.EXAM_DATES}`]: {
    es: 'Poca información sobre convocatorias',
    en: 'Little information about exams',
    cat: 'Poca informació sobre convocatòries',
    eus: 'Azterketa deiei buruzko informazio gutxi',
    pt: 'Poucas informações sobre ligações'
  },
  [`${EVoteReason.BETTER_CONTENT}`]: {
    es: 'Mejorar el contenido',
    en: 'Improve content',
    cat: 'Improvar el contingut',
    eus: 'Edukia hobetu',
    pt: 'Melhorar o conteúdo'
  },
  [`${EVoteReason.MORE_LIVE_CLASSES}`]: {
    es: 'Más clases en directo',
    en: 'More live classes',
    cat: 'Més classes en directe',
    eus: 'Zuzeneko klase gehiago',
    pt: 'Mais aulas ao vivo'
  },
  [`${EVoteReason.STUDENT_ATTENDANCE}`]: {
    es: 'Atención al alumno',
    en: 'Student support',
    cat: 'Suport al alumne',
    eus: 'Ikasleen arreta',
    pt: 'Suporte ao aluno'
  },
  [`${EVoteReason.TEACHERS}`]: {
    es: 'El profesorado',
    en: 'The teaching staff',
    cat: 'El professorat',
    eus: 'Irakasleak',
    pt: 'Corpo docente'
  },
  [`${EVoteReason.HELP_TO_USE_PLATFORM}`]: {
    es: 'Ayuda para usar la plataforma',
    en: 'Help to use the platform',
    cat: 'Ajuda per utilitzar la plataforma',
    eus: 'Gurekin erabili nahi duzun plataforma baten laguntza',
    pt: 'Ajuda para usar a plataforma'
  },
  [`${EVoteReason.MORE_CLARITY_HOW_TO_STUDY}`]: {
    es: 'Más claridad sobre cómo estudiar',
    en: 'More clarity on how to study',
    cat: 'Més claredat sobre com estudiar',
    eus: 'Ikasteko moduari buruzko argitasun gehiago',
    pt: 'Mais clareza sobre como estudar'
  },
  [`${EVoteReason.METHODS_ORIENTATION}`]: {
    es: 'Orientación sobre qué métodos usar',
    en: 'Orientation on which methods to use',
    cat: 'Orientació sobre quins mètodes utilitzar',
    eus: 'Metodologikoki orientatzea',
    pt: 'Orientação sobre quais métodos usar'
  },
  [`${EVoteReason.PREVIOUS_EXAMS}`]: {
    es: 'Exámenes de años anteriores',
    en: 'Previous years exams',
    cat: 'Proves de anys anteriors',
    eus: 'Aurreko urteetako azterketak',
    pt: 'Exames de anos anteriores'
  },
  [`${EVoteReason.BETTER_GENERAL_CONTENT}`]: {
    es: 'Mejor calidad de contenido',
    en: 'Better content quality',
    cat: 'Més bona qualitat de contingut',
    eus: 'Edukiaren kalitate hobea',
    pt: 'Melhor qualidade de conteúdo'
  },
  [`${EVoteReason.DONT_KNOW_START}`]: {
    es: 'No sé por dónde empezar',
    en: 'I don’t know where to start',
    cat: 'No sé per on començar',
    eus: 'Ez dakit non hasi',
    pt: 'Não sei por onde começar'
  },
  [`${EVoteReason.DONT_KNOW_USE_THE_APP}`]: {
    es: 'No sé cómo usar la plataforma',
    en: 'I don’t know how to use the platform',
    cat: 'No sé com utilitzar la plataforma',
    eus: 'Ez dakit nola erabili zure plataforma',
    pt: 'Não sei como usar a plataforma'
  },
  [`${EVoteReason.DONT_KNOW_ORGANIZE_STUDY}`]: {
    es: 'No sé cómo organizar mi estudio',
    en: 'I don’t know how to organize my study',
    cat: 'No sé com organitzar el meu estudi',
    eus: 'Ez dakit nola antolatu nire ikasketa',
    pt: 'Não sei como organizar o meu estudo'
  },
  [`${EVoteReason.DONT_KNOW_PRACTICE_MODE}`]: {
    es: 'No entiendo los modos de práctica',
    en: 'I don’t understand the practice modes',
    cat: 'No sé com utilitzar els modes de pràctica',
    eus: 'Ez ditut ulertzen praktika moduak',
    pt: 'Não sei como usar os modos de prática'
  },
  [`${EVoteReason.DONT_KNOW_TALK_TO_TUTOR}`]: {
    es: 'No sé cómo hablar con mi tutor',
    en: 'I don’t know how to talk to my tutor',
    cat: 'No sé com parlar amb el meu tutor',
    eus: 'Ez dakit nola hitz egin nire tutorearekin',
    pt: 'Não sei como falar com o meu tutor'
  },
  [`${EVoteReason.DONT_KNOW_SEE_RECORDED_CLASSES}`]: {
    es: 'No sé cómo ver las clases en directo',
    en: 'I don’t know how to see the live classes',
    cat: 'No sé com veure les classes en directe',
    eus: 'Ez dakit nola ikusi klaseak zuzenean.',
    pt: 'Não sei como ver as aulas ao vivo'
  },
  [`${EVoteReason.DONT_KNOW_FOLLOW_EXAMS}`]: {
    es: 'No se como seguir una convocatoria',
    en: 'I don’t know how to follow an exam',
    cat: 'No sé com seguir una convocatòria',
    eus: 'Ez dakit nola jarraitu azterketa bat',
    pt: 'Não sei como seguir uma convocatória'
  },

  WHAT_WILL_YOU_IMPROVE: {
    es: 'Cuéntanos lo que mejorarías',
    en: 'Tell us what you would improve',
    cat: 'Digues-nos què milloraria',
    eus: 'Zer hobetu nahi duzu',
    pt: 'Diga-nos o que melhoraria'
  },
  WOULD_YOU_RECOMMEND_UCADEMY: {
    es: '¿Recomendarías Ucademy a otra persona?',
    en: 'Would you recommend Ucademy to another person?',
    cat: 'Recomanarías Ucademy a una altra persona?',
    eus: 'Zer esan dezakezu Ucademy bat beste pertsorako?',
    pt: 'Recomendaria o Ucademy para outra pessoa?'
  },
  IS_EVERYTHING_CLEAR: {
    es: '¿Tienes claro cómo estudiar con nosotros?',
    en: 'Is everything clear on how to study with us?',
    cat: 'Tens clar com estudiar amb nosaltres?',
    eus: 'Argi daukazu nola ikasi gurekin?',
    pt: 'Tem certeza de como estudar con nós?'
  },
  IS_EVERYTHING_CLEAR_DESCRIPTION: {
    es: 'Queremos que sepas cómo avanzar en tu estudio desde el primer momento.',
    en: 'We want you to know how to advance in your study from the first moment.',
    cat: 'Volem que coneguis com avançar en el teu estudi des del primer moment.',
    eus: 'Gurekin ezinbesteko ikastetxean egiteko modua ezagutu nahi duzu.',
    pt: 'Queremos que saiba como avançar no seu estudo desde o primeiro momento.'
  },
  YES: {
    es: '👍 Sí',
    en: '👍 Yes',
    cat: '👍 Sí',
    eus: '👍 Bai',
    pt: '👍 Sim'
  },
  NO: {
    es: '👎 No',
    en: '👎 No',
    cat: '👎 No',
    eus: '👎 Ei',
    pt: '👎 Não'
  },
  ONBOARDING_NPS_PROMOTER_TITLE: {
    es: '😄 ¡Guay! ¿Qué es lo que más te ha gustado en tus primeros días?',
    en: '😄 Great! What did you like the most in your first days?',
    cat: '😄 Guau! Què t’ha agradat més en els teus primers dies?',
    eus: '😄 Guay! Zer gustatu zaizu gehien zure lehenengo egunetan?',
    pt: '😄 Ótimo! O que mais gostou nos seus primeiros dias?'
  },
  ONBOARDING_NPS_DETRACTOR_TITLE: {
    es: '🤔 ¿Qué faltó para que tu experiencia fuera excelente?',
    en: '🤔 What was missing to make your experience excellent?',
    cat: '🤔 Què faltava per fer que la teva experiència fos excel·lent?',
    eus: '🤔 Zer falta zituen zure ikastetxearen eragiketak egon zehatzago?',
    pt: '🤔 O que faltava para que a sua experiência fosse excelente?'
  },
  WHAT_DO_YOU_NOT_UNDERSTAND: {
    es: '🙁 Lo sentimos. ¿Qué es lo que no tienes claro?',
    en: '🙁 We are sorry. What do you not understand?',
    cat: '🙁 Ho sentim. Què no tens clar?',
    eus: '🙁 Gurek esan nahi duena, zer ez duzu argi?',
    pt: '🙁 Sentimos muito. O que não compreende?'
  },
  ADVENTURE_STARTS_HERE: {
    es: 'Aquí empieza la aventura',
    en: 'The adventure begins here',
    cat: 'L’aventura comenca aquí',
    eus: 'Aventura hasi hemen',
    pt: 'A aventura começa aqui'
  },
  CONTINUE_YOUR_STUDY: {
    es: 'Continúa tu aprendizaje',
    en: 'Continue your learning',
    cat: 'Continúa el teu aprenentatge',
    eus: 'Jarraitu zure ikastetxea',
    pt: 'Continuar o seu aprendizado'
  },
  START: {
    es: 'Empezar',
    en: 'Start',
    cat: 'Començar',
    eus: 'Hasita',
    pt: 'Começar'
  },
  CONTINUE: {
    es: 'Continuar',
    en: 'Continue',
    cat: 'Continuar',
    eus: 'Jarraitu',
    pt: 'Continuar'
  },
  CLASS_STARTED_AT: {
    es: 'Empezó hace {{time}} min',
    en: 'Started {{time}} min ago',
    cat: 'Començà fa {{time}} min',
    eus: 'Has emandako {{time}} minutu',
    pt: 'Começou {{time}} minutos atrás'
  },
  CLASS_STARTING_IN: {
    es: 'Comienza en {{time}} min',
    en: 'Starts in {{time}} min',
    cat: 'Comença en {{time}} min',
    eus: 'Has emandako {{time}} minutu',
    pt: 'Começa em {{time}} minutos'
  },
  JOIN_CLASS: {
    es: 'Unirme a la clase',
    en: 'Join the class',
    cat: 'Unir-me a la classe',
    eus: 'Klasean sartu',
    pt: 'Entrar na aula'
  },
  NO_LIVE_CLASS_LINK: {
    es: 'No existe enlace de la clase en directo',
    en: 'No live class link added',
    cat: 'No hi ha cap enllaç de la classe en directe',
    eus: 'Ez dago zuzenean egingo den klasearen esteka',
    pt: 'Nenhum link de aula ao vivo adicionado'
  },
  SEND: {
    es: 'Enviar',
    en: 'Send',
    cat: 'Enviar',
    eus: 'Bidali',
    pt: 'Enviar'
  },
  THANKS_FOR_YOUR_FEEDBACK: {
    es: '¡Gracias por tu valoración!',
    en: 'Thank you for your rating!',
    cat: 'Gràcies per la teva valoració!',
    eus: 'Zerindu zure ordena!',
    pt: 'Obrigado pela sua avaliação!'
  },
  YOU_SOMETHING_TO_SAY: {
    es: '¿Tienes algo que destacar o mejorar en esta clase?',
    en: 'Do you have something to highlight or improve in this class?',
    cat: '¿Tens alguna cosa que destacar o millorar en aquesta classe?',
    eus: 'Zer duzu zerbait argitaratu edo hobetu zenuen klasean?',
    pt: 'Tem algo para destacar ou melhorar nesta aula?'
  },
  WRITE_YOUR_COMMENT: {
    es: 'Escribe tu comentario...',
    en: 'Write your comment...',
    cat: 'Escriu el teu comentari...',
    eus: 'Idatzi zure iruzkin hau...',
    pt: 'Escreva o seu comentário...'
  },
  CANCEL: {
    es: 'Cancelar',
    en: 'Cancel',
    cat: 'Cancel·lar',
    eus: 'Utzi',
    pt: 'Cancelar'
  },
  CHAT_WIDGET_TITLE: {
    es: 'Chat con tutor',
    en: 'Chat with tutor',
    cat: 'Chat amb tutor',
    eus: 'Ikastetxearen tutorarekin harremanetan',
    pt: 'Chat com o tutor'
  },
  NO_MESSAGES: {
    es: 'No hay nuevos mensajes',
    en: 'No new messages',
    cat: 'No hi ha nous missatges',
    eus: 'Ez dago mezu berriak',
    pt: 'Não há novos mensagens'
  },
  POST_TAGS_COUNT_one: {
    es: '{{count}} formación',
    en: '{{count}} training',
    cat: '{{count}} formació',
    eus: '{{count}} ikastetxe',
    pt: '{{count}} formação'
  },
  POST_TAGS_COUNT_other: {
    es: '{{count}} formaciones',
    en: '{{count}} trainings',
    cat: '{{count}} formacions',
    eus: '{{count}} ikastetxeak',
    pt: '{{count}} formações'
  },
  EDIT: {
    es: 'Editar',
    en: 'Edit',
    cat: 'Editar',
    eus: 'Editatu',
    pt: 'Editar'
  },
  POST_CREATED_SUCCESSFULLY: {
    es: 'Post creado correctamente',
    en: 'Post created successfully',
    cat: 'Post creat correctament',
    eus: 'Posta behar bezala sortua',
    pt: 'Post criado com sucesso'
  },
  POST_UPDATED_SUCCESSFULLY: {
    es: 'Post actualizado correctamente',
    en: 'Post updated successfully',
    cat: 'Post actualitzat correctament',
    eus: 'Posta behar bezala eguneratua',
    pt: 'Post atualizado com sucesso'
  },
  POST_DELETED_SUCCESSFULLY: {
    es: 'Post eliminado correctamente',
    en: 'Post deleted successfully',
    cat: 'Post eliminat correctament',
    eus: 'Posta behar bezala ezabatua',
    pt: 'Post eliminado com sucesso'
  },
  TOPIC_CREATED_SUCCESSFULLY: {
    es: 'Tema creado correctamente',
    en: 'Topic created successfully',
    cat: 'Tema creat correctament',
    eus: 'Gai behar bezala sortua',
    pt: 'Tema criado com sucesso'
  },

  TOPIC_REMOVED_SUCCESSFULLY: {
    es: 'Tema eliminado correctamente',
    en: 'Topic removed successfully',
    cat: 'Tema eliminat correctament',
    eus: 'Gai behar bezala ezabatua',
    pt: 'Tema eliminado com sucesso'
  },
  RELATED_POSTS: {
    es: 'Artículos relacionados 👇',
    en: 'Related posts 👇',
    cat: 'Articles relacionats 👇',
    eus: 'Erlazionatutako artikuluak 👇',
    pt: 'Artigos relacionados 👇'
  },
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_POST: {
    es: '¿Estás seguro de querer eliminar este post?',
    en: 'Are you sure you want to delete this post?',
    cat: 'Estàs segur de voler eliminar aquest post?',
    eus: 'Zer zaude ziur zaude zerbitzua ezabatu nahi duzula?',
    pt: 'Tem certeza que deseja eliminar este post?'
  },
  STATUS: {
    es: 'Estado',
    en: 'Status',
    cat: 'Estat',
    eus: 'Egoera',
    pt: 'Estado'
  },
  SCHEDULE_POST: {
    es: 'Programar',
    en: 'Schedule',
    cat: 'Programar',
    eus: 'Planifikatu',
    pt: 'Programar'
  },
  SCHEDULE_POST_DATE: {
    es: 'Fecha',
    en: 'Date',
    cat: 'Data',
    eus: 'Data',
    pt: 'Data'
  },
  SCHEDULE_POST_TIMEZONE: {
    es: 'Zona horaria',
    en: 'Timezone',
    cat: 'Zona horària',
    eus: 'Denbora-zonal',
    pt: 'Fuso horário'
  },
  SCHEDULED_POST: {
    es: 'Programado',
    en: 'Scheduled',
    cat: 'Programat',
    eus: 'Planifikatua',
    pt: 'Programado'
  },
  PUBLISHED_POST: {
    es: 'Publicado',
    en: 'Published',
    cat: 'Publicat',
    eus: 'Argitaratua',
    pt: 'Publicado'
  },
  CREATE_NEWS: {
    es: 'Crear noticia',
    en: 'Create news',
    cat: 'Crear notícia',
    eus: 'Berri sortu',
    pt: 'Criar notícia'
  },
  EDIT_NEWS: {
    es: 'Editar noticia',
    en: 'Edit news',
    cat: 'Editar notícia',
    eus: 'Berriaren editatu',
    pt: 'Editar notícia'
  },
  PUBLISH_NEWS: {
    es: 'Publicar',
    en: 'Publish',
    cat: 'Publicar',
    eus: 'Argitaratu',
    pt: 'Publicar'
  },
  SAVE_CHANGES: {
    es: 'Guardar cambios',
    en: 'Save changes',
    cat: 'Guardar canvis',
    eus: 'Aldatuak gorde',
    pt: 'Guardar alterações'
  },
  SAVE_DRAFT: {
    es: 'Guardar como borrador',
    en: 'Save draft',
    cat: 'Guardar com a borrador',
    eus: 'Gorde zuzendua',
    pt: 'Guardar como rascunho'
  },
  DRAFT_POST: {
    es: 'Borrador',
    en: 'Draft',
    cat: 'Borrador',
    eus: 'Zuzendua',
    pt: 'Rascunho'
  },
  FEATURED_NEWS: {
    es: 'Noticia destacada',
    en: 'Featured news',
    cat: 'Notícia destacada',
    eus: 'Berri argitaratua',
    pt: 'Notícia destacada'
  },
  FEATURE_POST: {
    es: 'Publicar como destacada',
    en: 'Publish as featured',
    cat: 'Publicar com a destacada',
    eus: 'Argitaratu berri zehaztasuneko atala bezala',
    pt: 'Publicar como notícia destacada'
  },
  FEATURE_POST_TOOLTIP: {
    es: 'La noticia destacada aparece fija en la sección de noticias.',
    en: 'The featured post appears fixed in the news section.',
    cat: 'La notícia destacada apareix fixa en la secció de notícies.',
    eus: 'Berri argitaratua zehaztasuneko atala erakusten da.',
    pt: 'A notícia destacada aparece fixa na secção de notícias.'
  },
  NO_TAGS_SELECTED_ALERT: {
    es: 'Si no seleccionas ninguna formación, esta noticia se considerará como una noticia global, por lo que todos los alumnos la verán.',
    en: 'If you do not select any training, this news will be considered as a global news, so all students will see it.',
    cat: 'Si no selecciones cap formació, aquesta notícia es considerarà com a notícia global, per la qual cosa tots els alumnes la veuran.',
    eus: 'Ez baduzu ikastetxe bat hautatu, berria globala izango da, eta guztiak ikusi dituzte.',
    pt: 'Se não selecionar nenhuma formação, a notícia será considerada como uma notícia global, e todos os alunos a verão.'
  },
  DOWNLOAD_LIVE_CLASS_VOTE: {
    es: 'Descargar votos de clases en directo',
    en: 'Download live class votes',
    cat: 'Descargar votos de classes en directe',
    eus: 'Ekitaldi-klaseen ordenak deskargatu',
    pt: 'Descarregar votos de aulas ao vivo'
  },
  SEND_EMAIL_NOTIFICATION: {
    es: 'Enviar notificación por email',
    en: 'Send email notification',
    cat: 'Enviar notificació per email',
    eus: 'Posta elektronikoan jakinarazpen bidali',
    pt: 'Enviar notificação por email'
  },
  SEND_EMAIL_NOTIFICATION_TOOLTIP: {
    es: 'Los alumnos recibirán un email con el contenido de esta noticia.',
    en: 'The students will receive an email with the content of this news.',
    cat: "Els alumnes rebran un email amb el contingut d'aquesta notícia.",
    eus: 'Ikasleek posta elektronikoz berriaren edukia jasotuko dute.',
    pt: 'Os alunos receberão um email com o conteúdo desta notícia.'
  },
  CONTACT_WIDGET_TITLE: {
    es: 'Contacta con nosotros',
    en: 'Contact us',
    cat: 'Contacta amb nosaltres',
    eus: 'Erantzun eskubide',
    pt: 'Contate-nos'
  },
  CONTACT_BY_EMAIL: {
    es: 'Por email',
    en: 'By email',
    cat: 'Per email',
    eus: 'Posta elektronikoz harremanetan',
    pt: 'Por email'
  },
  CONTACT_BY_PHONE: {
    es: 'Por teléfono',
    en: 'By phone',
    cat: 'Per telèfon',
    eus: 'Telefonoz harremanetan',
    pt: 'Por telefone'
  },
  SCORE_MOBILE_SUBTITLE_BAD: {
    es: '0-6: No lo recomendaría, necesita mejorar',
    en: '0-6: I would not recommend it, it needs improvement',
    cat: '0-6: No recomanaria, necessita millorar',
    eus: '0-6: Ez da inoiz egin, behar duzu hobetu',
    pt: '0-6: Não recomendo, precisa melhorar'
  },
  SCORE_MOBILE_SUBTITLE_MIDDLE: {
    es: '7-8: Tiene margen de mejora',
    en: '7-8: It has room for improvement',
    cat: '7-8: Té marge per millorar',
    eus: '7-8: Egin behar duzu hobetu',
    pt: '7-8: Tem margem para melhorar'
  },
  SCORE_MOBILE_SUBTITLE_GOOD: {
    es: '9-10: Lo recomendaría',
    en: '9-10: I would recommend it',
    cat: '9-10: Recomanaría',
    eus: '9-10: Egin behar duzu egin',
    pt: '9-10: Recomendo'
  },
  GO_TO_PRACTICE: {
    es: 'Ir a practicar',
    en: 'Go to practice',
    cat: 'Ir a practicar',
    eus: 'Egin praktika',
    pt: 'Ir para prática'
  },
  WIDGET_TEST_DESCRIPTION: {
    es: 'Elige un modo de práctica y demuestra todo lo que has aprendido.',
    en: 'Choose a practice mode and show everything you’ve learned.',
    cat: 'Tria un mode de pràctica i demostra tot el que has après.',
    eus: 'Aukeratu praktika-modu bat eta erakutsi ikasitako guztia.',
    pt: 'Escolha um modo de prática e mostre tudo o que aprendeu.'
  },
  MAKE_A_TEST: {
    es: 'Haz un test',
    en: 'Make a test',
    cat: 'Fes un test',
    eus: 'Egin test bat',
    pt: 'Faça um teste'
  },
  VIEW_MORE: {
    es: 'Ver más',
    en: 'View more',
    cat: 'Veure més',
    eus: 'Ikusi gehiago',
    pt: 'Ver mais'
  },
  ATTEND_LIVE_CLASSES_WIDGET: {
    es: '{{count}} de {{total}} agendadas',
    en: '{{count}} of {{total}} scheduled',
    cat: '{{count}} de {{total}} programades',
    eus: '{{count}} eta {{total}} planifikatua',
    pt: '{{count}} de {{total}} programadas'
  },
  ADD_EXAM_GROUP: {
    es: 'Añadir',
    en: 'Add',
    cat: 'Afegeix',
    eus: 'Gehitu',
    pt: 'Adicionar'
  },
  EMPTY_EXAM_GROUPS: {
    es: 'No tienes convocatorias',
    en: "You don't have exam groups",
    cat: 'No tens convocatories',
    eus: 'Ez dituzu azterketa taldeak',
    pt: 'Não tem grupos de exames'
  },
  ADD_A_EXAM_GROUP: {
    es: 'Añade una convocatoria para tener tu meta a la vista.',
    en: 'Add an exam group to have your goal in sight.',
    cat: 'Afegeix una convocatoria per tenir la teva meta a la vista.',
    eus: 'Azterketa talde bat gehitu zure helburua ikus daitekeela.',
    pt: 'Adicione um grupo de exames para ter sua meta em vista.'
  },
  GO_TO_NEWS_PANEL: {
    es: 'Ir al panel de noticias',
    en: 'Go to news panel',
    cat: 'Anar al panel de notícies',
    eus: 'Joan panel berrietara',
    pt: 'Ir para o painel de notícias'
  },
  PUBLISH_NOW: {
    es: 'Enviar ahora',
    en: 'Publish now',
    cat: 'Enviar ara',
    eus: 'Bidali orain',
    pt: 'Enviar agora'
  },
  DELETE_POST_TITLE: {
    es: '¿Eliminar noticia?',
    en: 'Delete post?',
    cat: 'Eliminar notícia?',
    eus: 'Ezabatu berria?',
    pt: 'Excluir notícia?'
  },
  DELETE_POST_CONTENT: {
    es: 'Esta acción no se puede deshacer. ¿Estás seguro de que quieres eliminar esta noticia?',
    en: 'This action cannot be undone. Are you sure you want to delete this post?',
    cat: 'Aquesta acció no es pot desfer. Estàs segur que vols eliminar aquesta notícia?',
    eus: 'Ekintza hau ezin da desegin. Ziur zaude berri hau ezabatu nahi duzula?',
    pt: 'Esta ação não pode ser desfeita. Tem certeza de que deseja excluir esta notícia?'
  },
  PUBLISH_NOW_TITLE: {
    es: '¿Enviar noticia ahora?',
    en: 'Publish post now?',
    cat: 'Enviar notícia ara?',
    eus: 'Bidali berria orain?',
    pt: 'Enviar notícia agora?'
  },
  PUBLISH_NOW_CONTENT: {
    es: 'La noticia se publicará inmediatamente y estará visible para todos los usuarios.',
    en: 'The post will be published immediately and will be visible to all users.',
    cat: 'La notícia es publicarà immediatament i serà visible per a tots els usuaris.',
    eus: 'Berria berehala argitaratuko da eta erabiltzaile guztientzat ikusgai egongo da.',
    pt: 'A notícia será publicada imediatamente e ficará visível para todos os usuários.'
  },
  POST_PUBLISHED_NOW_SUCCESSFULLY: {
    es: 'La noticia se ha publicado correctamente',
    en: 'The post has been published successfully',
    cat: "La notícia s'ha publicat correctament",
    eus: 'Berria behar bezala argitaratu da',
    pt: 'A notícia foi publicada com sucesso'
  },
  SCHEDULED_AT: {
    es: 'Programado para el {{date}}',
    en: 'Scheduled for {{date}}',
    cat: 'Programat per {{date}}',
    eus: 'Planifikatuta {{date}}',
    pt: 'Programado para {{date}}'
  },
  SAVE: {
    es: 'Guardar',
    en: 'Save',
    cat: 'Guardar',
    eus: 'Gorde',
    pt: 'Guardar'
  },
  GLOBAL_NEWS: {
    es: 'Noticia global',
    en: 'Global news',
    cat: 'Notícia global',
    eus: 'Berri globala',
    pt: 'Notícia global'
  },
  ADDRESSEE_MORE: {
    es: '+{{count}} más',
    en: '+{{count}} more',
    cat: '+{{count}} més',
    eus: '+{{count}} gehiago',
    pt: '+{{count}} mais'
  },
  NO_TOPIC: {
    es: 'Sin tema',
    en: 'No topic',
    cat: 'Sense tema',
    eus: 'Gai gabe',
    pt: 'Sem tema'
  },
  NO_TITLE: {
    es: 'Sin título',
    en: 'Untitled',
    cat: 'Sense títol',
    eus: 'Izenbururik gabe',
    pt: 'Sem título'
  },
  FIELD_REQUIRED: {
    es: 'Por favor completa este campo',
    en: 'Please complete this field',
    cat: 'Si us plau completa aquest camp',
    eus: 'Mesedez bete eremu hau',
    pt: 'Por favor complete este campo'
  }
};
